
(function () {
  const ONCE = "thumbVariantPrefixFix";

  const getProductRoot = (el) =>
    el.closest('[data-product-variants]') ||
    el.closest('[data-section-id]') ||
    el.closest('.product, .product__info, .product-section') ||
    document;

  function syncFromThumb(thumb) {
    // Use your Liquid-provided handles/ids
    const baseHandle =
      thumb.dataset.o1Handle || thumb.dataset.valueHandle || "";
    const variantId = thumb.dataset.variantId || "";
    if (!baseHandle) return false;

    // Trendsetter swatch/option tokens look like: "<handle>}--<idx>"
    const tokenPrefix = `${baseHandle}}--`;
    const root = getProductRoot(thumb);

    // 1) Click the matching swatch button
    const swatchBtn = root.querySelector(
      `[data-swatch-button][data-button^="${tokenPrefix}"]`
    );
    if (swatchBtn) {
      swatchBtn.dispatchEvent(new MouseEvent("click", { bubbles: true }));
    }

    // 2) Also set the Option1 <select> (defensive)
    const optSelect =
      root.querySelector('select[dynamic-variant-input][data-index="option1"]') ||
      root.querySelector('select[name^="options["]');
    let chosenOption = null;
    if (optSelect) {
      chosenOption = [...optSelect.options].find((o) =>
        (o.dataset.valueHandle || "").startsWith(tokenPrefix)
      );
      if (chosenOption) {
        optSelect.value = chosenOption.value;
        optSelect.dispatchEvent(new Event("input", { bubbles: true }));
        optSelect.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    // 3) Sync the variant dropdown <select name="id"> by label text (and push ?variant=…)
    const label = chosenOption ? (chosenOption.textContent || "").trim() : null;
    const variantSelect =
      root.querySelector('select[name="id"][data-variant-select]') ||
      root.parentElement?.querySelector('select[name="id"][data-variant-select]');
    if (variantSelect) {
      let vOpt = null;
      if (label) {
        vOpt = [...variantSelect.options].find(
          (o) => (o.textContent || "").trim() === label
        );
      }
      if (!vOpt && variantId) {
        vOpt = [...variantSelect.options].find((o) => o.value === variantId);
      }
      if (vOpt) {
        variantSelect.value = vOpt.value;
        variantSelect.dispatchEvent(new Event("input", { bubbles: true }));
        variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
        const url = new URL(location.href);
        url.searchParams.set("variant", vOpt.value);
        history.replaceState({}, "", url.toString());
      }
    }

    // 4) Highlight active thumb
    thumb.closest("ul")?.querySelectorAll("[data-o1-handle], [data-value-handle]").forEach((t) => {
      t.classList.toggle("active", t === thumb);
    });

    return !!(swatchBtn || chosenOption || variantSelect);
  }

  function bind(scope = document) {
    if (scope instanceof HTMLElement) {
      if (scope.dataset[ONCE]) return;
      scope.dataset[ONCE] = "1";
    }
    scope.addEventListener("click", (e) => {
      const thumb = e.target.closest(
        '.product-thumbnails__item-link[data-o1-handle], .product-thumbnails__item-link[data-value-handle]'
      );
      if (!thumb) return;
      const ok = syncFromThumb(thumb);
      if (!ok) console.warn("[thumb→variant] No match. Check handles.");
    });
  }

  document.addEventListener("shopify:section:load", (e) => bind(e.target));
  document.addEventListener("shopify:section:select", (e) => bind(e.target));
  document.addEventListener("DOMContentLoaded", () => bind(document));
})();
